import React from 'react';
import type { InfoChipConfig } from '../types';

const variantClasses: Record<string, string> = {
  default: 'bg-slate-100 text-slate-700',
  warning: 'bg-amber-100 text-amber-800',
  success: 'bg-emerald-100 text-emerald-800',
  danger: 'bg-red-100 text-red-800',
};

export function MapInfoChip({ label, value, variant = 'default' }: InfoChipConfig) {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]}`}>
      <span className="text-[10px] uppercase tracking-wider opacity-60">{label}:</span>
      <span>{value}</span>
    </span>
  );
}
